// extracted by mini-css-extract-plugin
export var growableInput = "_8u-0";
export var tagContainer = "_8u-2";
export var textInput = "_8u-1";